import API from "../utils/api";

// In shiftClosingService.js — add explicit no-cache headers
const getOpenShift = async () =>
  (await API.get(`/api/shift-closings/open`, {
    headers: { 'Cache-Control': 'no-cache' },
    params: { _t: Date.now() } // ✅ cache-bust query param
  })).data;

const getUnclosedDates      = async () => (await API.get(`/api/shift-closings/unclosed`)).data;
const closeShift            = async (data) => (await API.post(`/api/shift-closings/close`, data)).data;
const getShiftClosings      = async () => (await API.get(`/api/shift-closings`)).data;
const getSingleShiftClosing = async (id) => (await API.get(`/api/shift-closings/${id}`)).data;

const shiftClosingService = {
  getOpenShift, getUnclosedDates,
  closeShift, getShiftClosings, getSingleShiftClosing,
};
export default shiftClosingService;